import React from "react";
import { Card, Stack, Typography, IconButton } from "@mui/material";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import {
  useAppSelector,
  useAppDispatch,
} from "../../../redux/hooks/redux-hooks";
import { getProjectDocument } from "../../../redux/actions/ProjectActions";

const DocumentsSection = () => {
  const dispatch = useAppDispatch();
  const projectDocuments = useAppSelector(
    (state) => state.projectDocuments.particular_ProjectDocuments
  );

  const handleDocumentClick = (docId: number) => {
    dispatch(getProjectDocument(docId));
  };

  return (
    <Card
      sx={{
        margin: "5px",
        padding: "10px",
        height: "100%",
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#312F2F",
        }}
      >
        Documents
      </Typography>
      {projectDocuments.length ? (
        <Stack spacing={1}>
          {projectDocuments.map((rec) => (
            <Stack key={rec.projectDocumentId} direction="row" spacing={2}>
              <Typography variant="body2">{rec.documentName}</Typography>
              <IconButton
                aria-label="Project Documents"
                color="primary"
                onClick={() => handleDocumentClick(rec.projectDocumentId)}
              >
                <FilePresentIcon />
              </IconButton>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" mt={2}>
          No Documents uploaded
        </Typography>
      )}
    </Card>
  );
};

export default DocumentsSection;
